import React from "react";
import { Link } from "react-router-dom";

import appStore from "../../assets/images/footer/appStore.svg";
import googlePlay from "../../assets/images/footer/googlePlay.svg";
import greenLogo from "../../assets/images/footer/footerGreenLogo.svg";

import "./footer.scss";
import { scrollToTop } from "constants/ScrollToTop";
import { logEvent } from "firebase/analytics";
import { analytics } from "../../firebase";
import Overlays from "container/Home/Overlays";

const Footer = ({ setCount }) => {
  return (
    <section className="footer">
      <Overlays />

      <div className="container footerContainer">
        <div className="footerTop">
          <Link
            className="footerLink"
            onClick={() => {
              scrollToTop();
              setCount(1);
            }}
            to="/"
          >
            <img src={greenLogo} alt="" className="logoFooter" />
          </Link>
          <div className="linksBox">
            <div className="links">
              <Link
                className="footerLink"
                to="/"
                onClick={() => {
                  scrollToTop();
                  setCount(1);
                }}
              >
                Home
              </Link>
              <Link
                className="footerLink"
                to="https://shop.neosapien.xyz"
                onClick={() => {
                  scrollToTop();
                  logEvent(analytics, "footer_order_now");
                }}
              >
                Products
              </Link>
              <Link
                className="footerLink"
                to="/about"
                onClick={() => {
                  logEvent(analytics, "about_us");
                }}
              >
                About us
              </Link>
              <Link
                className="footerLink"
                to="/contact"
                onClick={() => {
                  logEvent(analytics, "contact_us");
                }}
              >
                Contact Us
              </Link>
            </div>
            <div className="social">
              <Link
                className="footerLink"
                to="https://www.linkedin.com/company/neosapien/posts/?feedView=all"
                onClick={() => {
                  logEvent(analytics, "linkedin");
                }}
              >
                Linkedin
              </Link>
              <Link
                className="footerLink"
                to="https://x.com/neosapien_xyz"
                target="_blank"
                onClick={() => {
                  logEvent(analytics, "twitter");
                }}
              >
                Twitter
              </Link>
              <Link
                className="footerLink"
                to="https://www.youtube.com/@neosapien_xyz"
                onClick={() => {
                  logEvent(analytics, "youtube");
                }}
              >
                Youtube
              </Link>
              <Link
                className="footerLink"
                to="https://www.instagram.com/neosapien.xyz/"
                target="_blank"
              >
                Instagram
              </Link>
            </div>
            <div className="social">
              <Link
                className="footerLink"
                to="https://apps.apple.com/in/app/neosapien/id6740624306"
              >
                <img src={appStore} alt="" />
              </Link>
              <Link
                className="footerLink"
                to="https://play.google.com/store/apps/details?id=xyz.neosapien.neo"
              >
                <img src={googlePlay} alt="" />
              </Link>
            </div>
          </div>
        </div>
        <div className="line"></div>
        <div className="footerBottom">
          <p className="copy">Copyright © 2025</p>
          <div className="termsWrapper">
            <Link className="footerLink" to="/policies">
              <p>Privacy Policy</p>
            </Link>
            <p className="lines"></p>
            <Link
              className="footerLink"
              to="/terms-and-conditions#cancellation"
            >
              <p>Cancellation and Refund</p>
            </Link>
            <p className="lines"></p>
            <Link className="footerLink" to="/terms-and-conditions">
              <p>Terms of Services</p>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
